import React from "react"
import { Provider } from "react-redux"
import { createRoot } from "react-dom/client"
import { ToastContainer } from "react-toastify"

import { BrowserRouter }     from "react-router-dom"
import { ThemeProvider }    from "styled-components"

import { CookiesProvider } from "react-cookie"
import { mainTheme }        from "../../themes"

import LastLocationCookie from "./components/LastLocationCookie"
import configureStore from "./store"
import Main from "./components/Main"
import Header from "./components/Header"

const startApp = rootElem => {
  const store = configureStore()
  const root = createRoot(rootElem)
  root.render(
    <CookiesProvider>
      <Provider store={store}>
        <BrowserRouter>
          <ThemeProvider theme={mainTheme}>
            <Header />
            <Main />
            <LastLocationCookie />
            <ToastContainer autoClose={5000} />
          </ThemeProvider>
        </BrowserRouter>
      </Provider>
    </CookiesProvider>
  )
}

export default startApp
